import { Component, Input, } from '@angular/core';
import SlotSecondPageModel from '../../models/slot-second-page.model';

@Component({
  selector: '[order-details-slot]',
  templateUrl: './order-details-slot.component.html',
})
export default class OrderDetailsSlotComponent {
  @Input() slot: SlotSecondPageModel;

  constructor() {

  }

}
